<template>
  <narrow-container>
    <div
      id="loading"
      :class="{'show':inProgress}"
    />
    <h1 class="headline-secondary text--center">
      {{ this.$i18n.t('FORGOTTEN_LOGIN.HEADER') }}
    </h1>
    <p>
      {{ this.$i18n.t('FORGOTTEN_LOGIN.INFO') }}
    </p>
    <validated-input-box
      id="emailField"
      ref="emailField"
      :validation-reg-exp="emailRegex"
      :validation-error-message="$i18n.t('COMMON.ERROR_MESSAGES.EMAIL_ERROR')"
      :label="this.$i18n.t('FORGOTTEN_LOGIN.EMAIL')"
      name="emailField"
    />
    <submit-button
      id="forgottenLoginSubmitButton"
      :label="this.$i18n.t('FORGOTTEN_LOGIN.REQUEST_LOGIN')"
      :on-click="requestLogin"
      :disabled="!frcResponse"
    />
    <friendly-captcha-field
      ref="captcha"
      v-model="frcResponse"
    />
  </narrow-container>
</template>

<script>
import Regex from '@/constants/regex.json';
import FriendlyCaptchaField from '@/components/common/FriendlyCaptchaField.vue';

const VALIDATION_ERROR = 1;
const OTHER_ERROR = 9999;

export default {
  name: 'ForgottenLogin',
  components: { FriendlyCaptchaField },
  data: function() {
    return {
      inProgress: false,
      frcResponse: null,
    };
  },
  computed: {
    emailRegex: function() {
      return Regex.EMAIL;
    },
  },
  methods: {
    isFormValid: function() {
      const isValid = this.$refs.emailField.isValidBeforeSubmit();
      return isValid;
    },
    requestLogin: function() {
      if(this.isFormValid() && !this.inProgress && this.$refs.captcha.isValid()) {
        this.inProgress = true;
        let forgottenLoginRequest = {
          email: this.$refs.emailField.getFieldValue(),
        };
         this.$http.post('api/protected/dreitvkarte/forgottenLogin', forgottenLoginRequest, {
          headers: {
            'friendly-captcha-version': 'v2',
            'friendly-captcha-response': this.frcResponse
          }
          })
            .then( response => {
              this.processSuccessfulCallResponse(response);
            })
            .catch(callData => {
              this.processErrorCallResponse(callData);
              this.$refs.captcha.reset();
            })
            .finally(() => {
              this.inProgress = false;
            })
          }
    },
    processSuccessfulCallResponse: function() {
      this.$store.commit("setSuccessMessage", this.$i18n.t('FORGOTTEN_LOGIN.SUCCESS'));
      this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Forgotten login',label: 'Success', value: 0, noninteraction: false });
      this.$router.push({name: 'landing'});
    },
    processErrorCallResponse: function(callData) {
      if(callData.response === undefined || callData.response.data === undefined) {
        //this.$store.dispatch("googleAnalytics/createGoogleAnalyticsEvent", {eventCategory: 'Account', eventAction: 'App Registration', eventLabel: 'Error - Technical issue - no data'});
        this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
        this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Forgotten login',label: 'Error - no data', value: 0, noninteraction: false });
        return;
      }

      let responseCode = callData.response.data.responseCode;

      switch(responseCode) {
        case VALIDATION_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.VALIDATION_ERROR'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Forgotten login',label: 'Error - validation', value: 0, noninteraction: false });
          break;
        case OTHER_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Forgotten login',label: 'Error - technical issue', value: 0, noninteraction: false });
          break;
        default:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Forgotten login',label: 'Error - '+responseCode, value: 0, noninteraction: false });
        }
      },
  }
};
</script>

<style lang="scss" src="@/components/loading/loading.scss">
</style>
